export const navLinks = [
  { id: "scenes", label: "使用场景" },
  { id: "featured", label: "本周热映" },
  { id: "browse", label: "分类浏览" },
  { id: "quality", label: "高清画质" },
  { id: "speed", label: "极速观看" },
  { id: "guide", label: "观影指南" },
  { id: "ranking", label: "排行榜" },
  { id: "series", label: "剧集综艺" },
  { id: "faq", label: "常见问题" },
];

export const genreFilters = [
  { id: "all", label: "全部" },
  { id: "科幻", label: "科幻" },
  { id: "悬疑", label: "悬疑" },
  { id: "剧情", label: "剧情" },
  { id: "动作", label: "动作" },
  { id: "都市", label: "都市" },
  { id: "喜剧", label: "喜剧" },
  { id: "爱情", label: "爱情" },
  { id: "动画", label: "动画" },
  { id: "武侠", label: "武侠" },
];

export const sortOptions = [
  { id: "rating", label: "按评分排序" },
  { id: "year", label: "按年份排序" },
  { id: "title", label: "按片名排序" },
];

export const scenarioItems = [
  {
    id: "sc1",
    icon: "ri-subway-line",
    title: "通勤路上",
    desc: "单集二十分钟以内的剧集与综艺最适合碎片时间，起播快、缓冲少，进站前点开也不慌。",
  },
  {
    id: "sc2",
    icon: "ri-moon-clear-line",
    title: "睡前一集",
    desc: "调低亮度、开启柔和画质，观看纪录片或慢节奏剧情片更容易放松下来。",
  },
  {
    id: "sc3",
    icon: "ri-home-heart-line",
    title: "周末家庭",
    desc: "动画与合家欢影片支持蓝光画质投屏，全家人一起看时字幕与音量都能单独调节。",
  },
  {
    id: "sc4",
    icon: "ri-smartphone-line",
    title: "随时切换",
    desc: "同一账号在手机、平板、电视之间续看，播放进度与收藏列表会自动同步到当前设备。",
  },
];

export const qualityFeatures = [
  {
    id: "q1",
    icon: "ri-hd-line",
    title: "蓝光 1080P",
    desc: "基础清晰度即为蓝光档，码率随网络自适应，弱网时优先保住画面流畅而不是一味拉高分辨率。",
  },
  {
    id: "q2",
    icon: "ri-4k-line",
    title: "4K 超高清",
    desc: "画质完整的片源提供 3840×2160 输出，细节保留到发丝与织物纹理，适合大屏与投屏场景。",
  },
  {
    id: "q3",
    icon: "ri-contrast-drop-line",
    title: "HDR 高动态范围",
    desc: "暗部不再糊成一片，高光不过曝，夜景与太空场景的层次差异尤其明显。",
  },
  {
    id: "q4",
    icon: "ri-volume-up-line",
    title: "多声道音效",
    desc: "支持立体声与多声道输出，对白与环境音分离，戴耳机时台词更清楚。",
  },
  {
    id: "q5",
    icon: "ri-equalizer-line",
    title: "智能码率",
    desc: "根据实时网速在 720P 到 4K 之间平滑切换，切换过程不打断播放进度。",
  },
  {
    id: "q6",
    icon: "ri-closed-captioning-line",
    title: "字幕可调",
    desc: "多语言字幕可按需开关，字号、颜色与描边都能自行设置，方便投屏远距离观看。",
  },
];

export const speedFeatures = [
  {
    id: "sp1",
    icon: "ri-flashlight-line",
    title: "秒开起播",
    desc: "首帧预加载策略让平均起播时间控制在 1 秒左右，点开就开始，不用盯着转圈。",
  },
  {
    id: "sp2",
    icon: "ri-global-line",
    title: "就近节点",
    desc: "播放请求自动分配到距你最近的节点，跨区域访问时也会挑选延迟更低的线路。",
  },
  {
    id: "sp3",
    icon: "ri-history-line",
    title: "断点续看",
    desc: "退出后再次进入会自动定位到上次位置，误差通常在数秒以内，长剧集追起来更省心。",
  },
  {
    id: "sp4",
    icon: "ri-shield-check-line",
    title: "无广告干扰",
    desc: "播放过程不插入前贴或中插广告，正片从片头直接开始，观看节奏不被打断。",
  },
];

export const guideSteps = [
  {
    id: "g1",
    index: "01",
    title: "找到想看的影片",
    desc: "在分类浏览里按题材、年份或评分筛选，也可以直接输入片名关键词，列表会即时更新。",
  },
  {
    id: "g2",
    index: "02",
    title: "选择合适清晰度",
    desc: "点开卡片查看简介与可用画质，网络稳定时选蓝光或 4K，流量有限时切换自动档即可。",
  },
  {
    id: "g3",
    index: "03",
    title: "播放与调节",
    desc: "播放中可调整字幕、音量与画面比例，右侧会记录当前的播放进度方便返回。",
  },
  {
    id: "g4",
    index: "04",
    title: "收藏与续看",
    desc: "把喜欢的条目加入收藏，下次打开时直接从收藏列表或继续观看区接着看。",
  },
];

export const faqItems = [
  {
    id: "f1",
    question: "神马电影网主要提供什么内容？",
    answer:
      "本站围绕在线观看场景，整理了影片、剧集、综艺与纪录片等内容入口，并按题材、年份、评分做了分类。你可以在分类浏览区按条件筛选，也可以从排行榜和本周热映里直接挑选。",
  },
  {
    id: "f2",
    question: "观看是免费的吗，需要注册吗？",
    answer:
      "页面展示的片库信息与浏览体验无需付费即可查看。是否注册取决于你想使用的功能，例如同步收藏与续看记录；仅浏览与筛选不需要额外步骤。",
  },
  {
    id: "f3",
    question: "蓝光画质和 4K 有什么区别？",
    answer:
      "蓝光通常指 1080P 的清晰度，已经能满足大多数手机与笔记本屏幕；4K 达到 3840×2160，在电视或投屏上细节更明显。搭配 HDR 后，夜景的暗部层次会比普通清晰度好很多。",
  },
  {
    id: "f4",
    question: "为什么有时候起播会慢一点？",
    answer:
      "起播速度主要受本地网络与所在线路影响。如果短时间内容易缓冲，可以先把清晰度切换到自动档，播放器会根据实时网速在档位之间平滑调整，通常几秒内恢复流畅。",
  },
  {
    id: "f5",
    question: "手机上观看体验好吗？",
    answer:
      "页面按移动端做了适配，筛选栏、卡片列表和弹窗在窄屏下都能正常操作。播放界面支持手势调节，横屏后字幕位置也会自动避让系统栏。",
  },
  {
    id: "f6",
    question: "播放过程中会有广告吗？",
    answer:
      "按当前页面说明，播放链路以“无广告”为设计目标，正片从片头直接开始。若你遇到异常插入的内容，可通过页面底部的反馈入口告诉我们。",
  },
];